import { connect } from 'react-redux'

import { doRenderTicketListBeforeSearch } from 'actions/app'
import { doFetchTopLabels, doSearchLabels } from 'actions/labels'
import {
  doUpdateTicketSearchQuery,
  doToggleListSearchBoxFocused,
} from 'actions/search'
import { doSetFlag, selectFlag } from 'ducks/flags'
import { HIDE_INBOX_SEARCH_FILTER_CALLOUT } from 'ducks/flags/flagNames'
import {
  selectCurrentFolderContext,
  selectTicketListBeforeSearch,
} from 'selectors/app'
import { foldersByIdSelector } from 'selectors/folders'
import { selectLabelsByMailboxId } from 'selectors/labels'
import { selectLabelSearchResultsByTerm } from 'selectors/labelings'
import {
  selectCurrentUncommittedTicketSearchQueryString,
  selectCurrentCommittedTicketSearchQueryString,
  selectDisplayedSearchQueryString,
  selectCurrentTicketSearchSelectionStart,
  selectCurrentCommittedTicketSearchQueryCurrentPart,
} from 'selectors/search/base'
import { selectTicketSearchSuggestions } from 'selectors/search_suggestions'
import { selectIsFreeFormSearch, selectIsTypedSearch } from 'selectors/search'

import SearchView from 'components/ConversationList/Header/Search'

const select = state => {
  return {
    committedSearchQuery: selectCurrentCommittedTicketSearchQueryString(state),
    currentPart: selectCurrentCommittedTicketSearchQueryCurrentPart(state),
    folderContext: selectCurrentFolderContext(state),
    foldersById: foldersByIdSelector(state),
    isFreeFormSearch: selectIsFreeFormSearch(state),
    labelsByTerm: selectLabelSearchResultsByTerm(state),
    searchQuery: selectDisplayedSearchQueryString(state),
    searchSelectionStart: selectCurrentTicketSearchSelectionStart(state),
    suggestions: selectTicketSearchSuggestions(state),
    conversationListBeforeSearch: selectTicketListBeforeSearch(state),
    topLabels: selectLabelsByMailboxId(state).null,
    uncommittedSearchQuery: selectCurrentUncommittedTicketSearchQueryString(
      state
    ),
    isTypedSearch: selectIsTypedSearch(state),
    shouldHideInboxSearchFilterNewLabel: selectFlag(state)(
      HIDE_INBOX_SEARCH_FILTER_CALLOUT
    ),
  }
}

const perform = {
  doFetchTopLabels,
  doSearchLabels,
  doToggleListSearchBoxFocused,
  doUpdateTicketSearchQuery,
  doSetFlag,
  onClearClick: doRenderTicketListBeforeSearch,
}

export default connect(select, perform)(SearchView)
